import { Component, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Componente atômico para renderizar HTML de forma segura.
 *
 * Protege contra ataques XSS (Cross-Site Scripting) ao sanitizar
 * o conteúdo HTML antes de renderizá-lo.
 *
 * **Uso recomendado:**
 * - Renderizar conteúdo HTML dinâmico (ex: traduções com tags HTML)
 * - Exibir conteúdo de rich text editors
 * - Mostrar conteúdo de APIs que retornam HTML
 *
 * **Segurança:**
 * - Remove scripts maliciosos
 * - Remove event handlers perigosos (onclick, onerror, etc)
 * - Mantém apenas tags e atributos seguros
 *
 * @example
 * ```html
 * <lib-safe-html [content]="'Texto com <strong>HTML</strong>'" />
 * ```
 *
 * @example
 * ```html
 * <lib-safe-html [content]="translatedContent | translate" />
 * ```
 */
@Component({
  standalone: true,
  selector: 'lib-safe-html',
  template: '<span [innerHTML]="sanitizedContent()"></span>',
  styles: [`
    :host {
      display: contents;
    }
  `]
})
export class SafeHtmlLibComponent {
  /**
   * Conteúdo HTML a ser renderizado de forma segura
   */
  content = input.required<string>();

  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Retorna o conteúdo HTML sanitizado
   * Remove scripts e conteúdo potencialmente perigoso
   */
  protected sanitizedContent(): SafeHtml {
    return this.sanitizer.sanitize(1, this.content()) || '';
  }
}
